import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodCompanyAccountDeletionCheckResponseSchema } from './validations';

/**
 * Checks whether a company account can be deleted.
 *
 * @param companyAccountId - The company account ID to check.
 * @param options - Additional request options, such as an abort signal.
 * @returns Whether deletion is allowed and any blockers.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Account/operation/check_company_account_deletion_vadmin_company_accounts__company_account_id__deletion_check_get
 */
export async function fetchCompanyAccountDeletionCheck(
  companyAccountId: UUID,
  options?: KyRequestOptions,
) {
  const response = await vestigasApi
    .get(ENDPOINT.COMPANY.ACCOUNT.DELETION_CHECK(companyAccountId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodCompanyAccountDeletionCheckResponseSchema,
      },
    })
    .json<unknown>();

  return zodCompanyAccountDeletionCheckResponseSchema.parse(response);
}
